module.exports = __webpack_public_path__ + "img/avatar_33.48dae2b5.svg";